module.exports = __webpack_public_path__ + "img/logo.5daebac1.png";